import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { BalanceService } from '../../balance/balance.service';
import { SessionService } from '../session/session.service';
import { SettingsService } from '../settings/settings.service';
import { SystemConfig } from '../../config/system-config';
import { User } from '../../domain/user';
import { LoginRequest } from '../../domain/login-request';

@Injectable()
export class LoginService {

  constructor(private http: Http,
              private balanceService: BalanceService,
              public sessionService: SessionService,
              public settingsService: SettingsService) {
    }

  validateLogin(loginRequest: LoginRequest): Observable<any> {
    let headers: Headers = new Headers();
    return this.http.post(SystemConfig.Endpoint.LOGIN, loginRequest, {
      headers: headers
    });
  }

  validateUserAccount(): void {
    let headers: Headers = new Headers();
    this.http.get(SystemConfig.Endpoint.USER_ACCOUNT_SETTINGS, {
      headers: headers
    }).subscribe(
        (response: any) => this.handleUserAccountResponse(response));
  }

  handleUserAccountResponse(response: Response) {
      try {
          let account: any = response.json();
          this.sessionService.punter = new User(account.Username, null);
          this.balanceService.updateBalance();
      } catch (ignored) {
      }
  }
}


// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/shared/services/login/login.service.ts